export const EPaymentType = {
    POINTS_CASH: 5,
    ONLY_CASH: 2
}

export const EVendorType = {
    POINTS_PURCHASE: 'Compra de Pontos',
    MILES_PURCHASE: 'Milhas',
    DONATION: 'Doação',
    PAY_BILLS: 'Pague Contas',
    INVOICE_CREDIT: 'Crédito em Fatura',
    EXTERNAL_VOUCHER: 'Voucher Virtual Externo',
    E_COMMERCE: 'e-Commerce',
}
